export default __webpack_public_path__ + "static/media/mediumcard.a27de592.svg";